import { C } from "@/brand/tokens";

export function Eyebrow6({ children, rule = true, className = "", testId }) {
  return (
    <div className={`flex items-center gap-4 ${className}`} data-testid={testId}>
      {rule && (
        <span
          aria-hidden="true"
          className="inline-block h-px w-12 shrink-0"
          style={{ background: C.accentMetal }}
        />
      )}
      <p
        className="font-inter text-[11px] uppercase font-semibold"
        style={{ color: C.accentMetal, letterSpacing: "0.26em" }}
      >
        {children}
      </p>
    </div>
  );
}
